import { Component, Input, OnInit } from "@angular/core"
import { ModalRef } from "../../../shared-components/modal/modal-ref"
import { LMModalService } from "../../../services/lm-modal.service"
import { Media } from "../../../models/resource/media"
import { ResourceService } from "../../../services/resource.service"
import Utils from "../../../utils/utils"

@Component({
    selector: "app-agreement-modal",
    templateUrl: "./agreement-modal.component.html",
    styleUrls: ["./agreement-modal.component.scss"],
    standalone: false,
})
export class AgreementModalComponent implements OnInit {
    downloadRetrievalUrl: string
    downloadUrl: string
    fileSize: string = "N/A"
    fileType: string = "N/A"
    isAgreementChecked: boolean
    isDownloadReady: boolean

    @Input() selectedMedia: Media

    constructor(
        public activeModal: ModalRef,
        public lmModalService: LMModalService,
        private resourceService: ResourceService
    ) {}

    ngOnInit() {
        this.downloadRetrievalUrl = this.selectedMedia.download.url
        this.fileType = this.selectedMedia.download.file_type || this.fileType
        const fileSize = this.selectedMedia.download.file_size
        this.fileSize = fileSize
            ? `${fileSize.toFixed(2)}` === "0.00"
                ? `${fileSize.toFixed(4)} MB`
                : `${fileSize.toFixed(2)} MB`
            : this.fileSize
        this.isDownloadReady = this.selectedMedia.download.is_download_ready
        if (!this.isDownloadReady) {
            this.triggerZipBuild()
        }
    }

    onDownloadClick() {
        this.getAssetDownloadUrl().subscribe((assetData: any) => {
            if (Utils.isEmpty(assetData["downloadUrl"])) {
                this.isDownloadReady = false
            } else {
                this.activeModal.close()
                window.location.href = assetData["downloadUrl"]
            }
        })
    }

    updateAgreementState() {
        this.isAgreementChecked = !this.isAgreementChecked
    }

    getAssetDownloadUrl() {
        return this.resourceService.getAssetDownloadUrl(this.downloadRetrievalUrl)
    }

    triggerZipBuild() {
        this.getAssetDownloadUrl().subscribe()
    }
}
